<template>
  <div
    class="questions-item"
    @click="gotoIm"
  >
    <span>{{text}}</span>
    <z-icon class-prefix="zziconfont" name="arrow-right" class="questions-item-icon"/>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Icon } from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'
export default {
  name: 'LinkCell',
  data() {
    return {
      imUrl: 'https://m.zhuanzhuan.com/system/zzappimservice/index.html?' // im地址
    }
  },
  props: {
    text: { // 跳转到im携带的问题
      type: String
    },
    skillId: {
      type: String
    },
    athenaChannel: {
      type: String
    },
    legoId: {
      type: String
    },
    fromPage: {
      type: String
    },
    curBizCate: {
      type: Object
    }
  },
  computed: {
    skipImUrl() {
      console.log('recommandOrders', this.curBizCate)
      if (this.fromPage === 'RECOMMANDQUESTIONS' || this.fromPage === 'RECOMMANDORDER') {
        const { businessCategoryId: businessId } = this.curBizCate
        return `${this.imUrl}skillId=${this.skillId}&athenaChannel=${this.athenaChannel}&businessId=${businessId}&questionText=${this.text}`
      }
      return `${this.imUrl}skillId=${this.skillId}&athenaChannel=${this.athenaChannel}&questionText=${this.text}`
    }
  },
  components: {
    zIcon: Icon
  },
  methods: {
    gotoIm() { // 点击去IM会话，并自动发送聊天
      const skipImUrl = this.skipImUrl
      console.log('skipImUrl-cell', skipImUrl)
      const legoActionType = `ZZUP_NEWHELPCENTER_${this.fromPage}_CLICK`
      lego.send({
        pagetype: 'ZZUP_NEWHELPCENTER',
        actiontype: legoActionType,
        backup: {
          queId: this.legoId
        }
      })
      native.skipToUrl({
        targetUrl: skipImUrl
      })
    }
  }
}
</script>
<style lang="less" scoped>
  @import './index.less';
</style>